/**
 * Plan and checkout button colours, picked with `useTheme().resolvedTheme` instead of `dark:`
 * classes, which lost to the Button's own colours in dark mode.
 */
export const primaryButtonClass = (isDark: boolean) =>
  isDark ? '!bg-true-white !text-black hover:!bg-zinc-200' : '!bg-black !text-white hover:!bg-zinc-800';

export const secondaryButtonClass = (isDark: boolean) =>
  isDark
    ? 'border-white/20 !bg-transparent !text-white hover:!bg-white/10'
    : 'border-black/15 !bg-transparent !text-black hover:!bg-black/5';
